"use strict"

import { Report, ReportDataTable } from '@/lib/core/components/reports/report'
import { TerrenosDM } from '@/lib/core/terrenos/terrenos'
import {
  DistritosFilterFieldSelect,
  StatusFilterFieldSelect,
  ZoneamentosFilterFieldSelect,
  EstadosFilterFieldSelect,
  CidadesFilterFieldSelect,
} from '@/lib/core/reports/FilterFieldSelect'

export class TerrenosPorCorretorReport extends Report {
  #config
  constructor({ Logic, custom }) {
    super({ Logic, originClass: TerrenosPorCorretorReport, custom })
    this.#config = {
      filters: ['distritos', 'zoneamentos', 'status'],
    }
  }
  get config() { return this.#config }
  async build({ register, fields, customSpecialFields, config }) {
    const _customSpecialFields = {
      distritos: DistritosFilterFieldSelect,
      status: StatusFilterFieldSelect,
      zoneamentos: ZoneamentosFilterFieldSelect,
      estados: EstadosFilterFieldSelect,
      cidades: CidadesFilterFieldSelect,
      table: TerrenosPorCorretorReportDataTable,
      ...customSpecialFields
    }
    const _config = { ...this.#config, ...config }
    await super.build({ register, fields, customSpecialFields: _customSpecialFields, config: _config })
    return this
  }
  async getRegistersList() {
    const registers = (new TerrenosDM({}))
    await registers
      .list
      .read({
        project: { codigo: 1, nome: 1, endereco: 1, distrito: 1, link_distrito: 1, quadra: 1, link_quadra: 1, status: 1, link_status: 1, ofertas: 1, zoneamentos: 1 }
      })
    return registers.list
  }
}

export class TerrenosPorCorretorReportDataTable extends ReportDataTable {
  constructor({ form, register, fields, multiline, field, name = 'table', Logic }) {
    super({ form, register, fields, multiline, field, name, Logic, originClass: TerrenosPorCorretorReportDataTable })
  }
  getConfig() {
    return {
      0: {
        headers: [
          { text: "Corretor", value: "link_corretor", align: "start" },
          { text: "Quantidade", value: "quantidade", align: "center", dataType: "number" }
        ],
        footers: ({ registersFiltereds }) => [
          { text: "Total", class: "total" },
          { text: registersFiltereds?.length, class: "valorTotal" }
        ],
        fill: ({ registersFiltereds }) => {
          const linesRaw = registersFiltereds.map(register => {
            const lastOferta = register.ofertas?.getLast?.()
            const idCorretor = lastOferta?.corretor
            if (idCorretor && String(idCorretor).trim() !== '') {
              return {
                corretor: idCorretor,
                link_corretor: lastOferta?.link_corretor || `${idCorretor} - (Corretor não cadastrado)`
              }
            }
            return { corretor: null, link_corretor: 'Terrenos sem corretor' }
          })
          const pertenceAoCorretor = (register, corretorId) => {
            const idCorretor = register.ofertas?.getLast?.()?.corretor
            if (corretorId === null || corretorId === undefined) {
              return !idCorretor || (typeof idCorretor === 'string' && idCorretor.trim() === '')
            }
            return idCorretor === corretorId
          }
          const corretoresUniq = linesRaw.removeDuplicatesObjectsProp('corretor')
          const corretorTableData = corretoresUniq.map(line => {
            const quantidade = registersFiltereds.filter(register => pertenceAoCorretor(register, line.corretor)).length
            return {
              _id: line.corretor ?? 'Terrenos sem corretor',
              corretor: line.corretor,
              link_corretor: line.link_corretor,
              quantidade
            }
          })
          return corretorTableData
        },
        clickRow: () => {}
      },
      1: {
        headers: [
          { text: 'Código', value: 'codigo', align: 'center', dataType: "number" },
          { text: 'Nome', value: 'nome', align: 'start' },
          { text: 'Endereço', value: 'endereco', align: 'start' },
          { text: 'Distrito', value: 'link_distrito', align: 'center' },
          { text: "Quadra", value: "link_quadra", align: 'center' },
          { text: 'Status', value: 'link_status', align: 'center' },
          { text: 'Corretor', value: 'link_corretor', align: 'center' }
        ],
        footers: () => [],
        fill: ({ registersFiltereds, item }) => {
          if (!Array.isArray(registersFiltereds) || registersFiltereds.length == 0 || !item) { return }
          const pertenceAoCorretor = (register) => {
            const idCorretor = register.ofertas?.getLast?.()?.corretor
            if (item.corretor === null || item.corretor === undefined) {
              return !idCorretor || (typeof idCorretor === 'string' && idCorretor.trim() === '')
            }
            return idCorretor === item.corretor
          }
          return registersFiltereds
            .filter(pertenceAoCorretor)
            .map(register => {
              const lastOferta = register.ofertas?.getLast?.()
              return { ...register, link_corretor: lastOferta?.link_corretor || lastOferta?.corretor || '' }
            })
        },
        clickRow: ({ item }) => {
          window.jsf.openInNewWindow({ name: 'data', query: { hmenuOpened: 'Dados', menuId: 'terrenos', id: item._id } })
        }
      }
    }
  }
  clickCell() {}
}